import { store } from "../../app/store";
import { Logger } from "../../tools/Logger";
import { ping } from "./aircraftAPI";
import { Sim } from "./types";
import { aircraftConnecting, onPingFinish, onPingStart } from "./aircraftSlice";
import { WebSocketPair } from "./WebSocketPair";

export class UavConnection {
  private TAG = "UavConnection";
  private sims: Sim[] = [];
  private token: string = "";

  private uavId: string = "";
  private socketPair: WebSocketPair | null = null;

  constructor(sims: Sim[], token: string, uavId: string, port: string) {
    this.sims = sims.map((sim) => ({
      ...sim,
      active: false,
      available: false,
    }));
    this.token = token;
    if (uavId) {
      this.uavId = uavId;
    }
    store.dispatch(aircraftConnecting({ uavId: this.uavId }));

    this.socketPair = new WebSocketPair(
      this.sims[0]?.ip,
      this.sims[1]?.ip || this.sims[0]?.ip,
      this.token,
      this.uavId,
      port
    );
    this.testSims();
  }

  public getUavId = () => {
    return this.uavId;
  };

  public destroyConnection = () => {
    try {
      this.socketPair?.destroyConnection();
      this.socketPair = null;
    } catch (err) {
      console.log(err);
      Logger.error(this.TAG, `${this.uavId}`);
    }
  };

  public send = (data: string) => {
    this.socketPair?.send(data);
  };

  private testSims = async () => {
    try {
      Logger.debug(this.TAG + ` ${this.uavId}`, `startConnection`);
      this.pingSims();
    } catch (err) {
      Logger.error(this.TAG + ` ${this.uavId}`, err);
    }
  };

  private pingSims = async (): Promise<string> => {
    try {
      Logger.debug(
        this.TAG + ` ${this.uavId}`,
        `pingSims ${this.sims.map((sim) => sim.ip).join(", ")}`
      );

      store.dispatch(onPingStart({ id: this.uavId, sims: this.sims }));

      const succeededPing = await Promise.any(
        this.sims.map((sim) => this.ping(sim.ip))
      );
      Logger.info(
        this.TAG + ` ${this.uavId}`,
        `pingSims successful with ${succeededPing}`
      );
      return succeededPing;
    } catch (err) {
      Logger.error(this.TAG + ` ${this.uavId}`, err);
      throw err;
    }
  };

  private ping = async (ip: string) => {
    try {
      Logger.debug(this.TAG + ` ${this.uavId}`, `ping ${ip}`);
      await ping(ip);
      Logger.info(this.TAG + ` ${this.uavId}`, `ping ${ip} success`);
      store.dispatch(onPingFinish({ id: this.uavId, ip, success: true }));

      return ip;
    } catch (err) {
      store.dispatch(onPingFinish({ id: this.uavId, ip, success: false }));
      Logger.error(this.TAG + ` ${this.uavId}`, `ping ${ip} failed`);
      throw err;
    }
  };
}
